// Value formatting for KPI widgets. `displayConfig.format` (or a KPI's
// definition `unit`) selects the formatter; default is locale number.

export function formatBytes(n) {
    const x = Number(n);
    if (!isFinite(x)) return "--";
    if (x === 0) return "0 B";
    const neg = x < 0 ? "-" : "";
    const abs = Math.abs(x);
    const units = ["B", "KB", "MB", "GB", "TB", "PB"];
    const i = Math.min(Math.floor(Math.log(abs) / Math.log(1024)), units.length - 1);
    const v = abs / Math.pow(1024, i);
    const digits = i === 0 ? 0 : v >= 100 ? 0 : v >= 10 ? 1 : 2;
    return `${neg}${v.toFixed(digits)} ${units[i]}`;
}

export function formatNumber(n) {
    const x = Number(n);
    if (!isFinite(x)) return "--";
    return x.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

// Returns a (value) => string formatter for the given format key.
export function makeValueFormatter(format) {
    if (format === "bytes") return formatBytes;
    return formatNumber;
}

// KPI ids are snake_case; show them as words ("disk_free_space" -> "Disk Free
// Space"). Words with a conventional casing (acronyms, units) keep it so ids
// like "media_server_nic_tx_mbps" don't read as "Nic Tx Mbps".
const WORD_CASING = {
    api: "API", cpu: "CPU", gpu: "GPU", ip: "IP", id: "ID", kpi: "KPI",
    nic: "NIC", ram: "RAM", rss: "RSS", rtt: "RTT", ui: "UI", url: "URL",
    tx: "TX", rx: "RX", pps: "PPS", mbps: "Mbps", kbps: "Kbps",
    ms: "ms", pct: "%", p99: "p99", db: "DB", os: "OS",
};

export function formatKpiLabel(id) {
    if (!id) return "";
    return String(id)
        .split(/[_\s-]+/)
        .filter(Boolean)
        .map((w) => WORD_CASING[w.toLowerCase()] || w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
}
